import { render, staticRenderFns } from "./step_six.vue?vue&type=template&id=5a684806&scoped=true"
import script from "./step_six.vue?vue&type=script&lang=js"
export * from "./step_six.vue?vue&type=script&lang=js"
import style0 from "./step_six.vue?vue&type=style&index=0&id=5a684806&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a684806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a684806')) {
      api.createRecord('5a684806', component.options)
    } else {
      api.reload('5a684806', component.options)
    }
    module.hot.accept("./step_six.vue?vue&type=template&id=5a684806&scoped=true", function () {
      api.rerender('5a684806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/doubleRandom/projectExtract/step_six.vue"
export default component.exports